// extracted by mini-css-extract-plugin
export var cardlink = "PromoCardNavigation-module--cardlink--6d2d2";
export var imagebackground = "PromoCardNavigation-module--imagebackground--a361f";
export var imagebackgroundoverlay = "PromoCardNavigation-module--imagebackgroundoverlay--ce1cc";
export var pretitle = "PromoCardNavigation-module--pretitle--b8933";
export var promocardnav = "PromoCardNavigation-module--promocardnav--b7120";
export var title = "PromoCardNavigation-module--title--d2f4c";